import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Text, Loading } from "@foris/avocado-suite";
import useDisableSection from "../hooks/useDisableSection";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import useContextUrl from "@common/hooks/useContextUrl";
import Modal from "@components/modal";

interface DeleteSectionModalProps {
  isOpen?: boolean;
  onCancel?: () => void;
}

const DeleteSectionModal = ({ isOpen, onCancel }: DeleteSectionModalProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { workspace, scenario, origin } = useContextUrl();
  const { homeUrl } = useNavigationUrl();

  const { handleDisableSection, validations, setValidations, isLoading } = useDisableSection({
    onSuccess: () => {
      history.replace(homeUrl(workspace, scenario, origin), {
        sectionDelete: true,
      });
    },
  });

  const handleOnClose = () => {
    if (isLoading) return;

    setValidations([]);
    onCancel?.();
  };

  return (
    <>
      {isLoading && <Loading />}

      {!isLoading && !validations?.length && (
        <Modal
          typeState="confirm"
          show={isOpen}
          title={t("dimension.section.delete-section.confirm-modal.title")}
          subtitle={t("dimension.section.delete-section.confirm-modal.subtitle")}
          onClose={() => !isLoading && handleOnClose?.()}
          colorButtonPrincipal="danger"
          textButtonPrincipal={t("dimension.section.delete-section.confirm-modal.action-btn")}
          textButtonSecondary={t("generals.cancel")}
          onClickPrincipal={() => handleDisableSection()}
          onClickSecondary={() => !isLoading && handleOnClose?.()}
          isLoading={isLoading}
        >
          <Text>{t("dimension.section.delete-section.confirm-modal.description")}</Text>
        </Modal>
      )}

      <Modal
        typeState="error"
        show={!!validations?.length}
        title={t("dimension.section.delete-section.error-modal.title")}
        onClose={() => !isLoading && handleOnClose()}
        textButtonSecondary={t("generals.ok")}
        onClickSecondary={() => !isLoading && handleOnClose()}
        isLoading={isLoading}
      >
        {validations.map((validation, index) => (
          <>
            <Text key={index}>{validation?.message}</Text>
            {index < validations.length - 1 && <br key={`br-${index}`} />}
          </>
        ))}
      </Modal>
    </>
  );
};

export default DeleteSectionModal;
